import { colors } from './colors'
import { fonts } from './fonts'
import { shadows } from './shadows'

export const foundations = {
    colors,
    shadows,
    fonts,
}
